import React from 'react';
import cloneDeep from 'lodash.clonedeep';
import GlobalLightbox from '../../components/Image/GlobalLightbox';
import RenderComponent from './RenderComponent';
import getComponentsToInsertByType from './get-components-to-insert-by-type';
import injectElementComponents from './inject-element-components';
import StoreImages from './StoreImages';
import getLightboxImages from './get-lightbox-images';
import insertBanners from './insert-banners';
import checkBannerInsertionSet from './check-banner-insertion-set';
import getBannerIndex from './get-banner-index';
import { ELEMENT } from '../../constants';
import { PB_TYPE_TEXTBLOCK } from './constants';

function renderChildComponents(options, items = []) {
  return items && items.length ? BuildPBComponents(items, options) : [];
}

function BuildPBComponents(components, options = {}, rootLevel = false) {
  const isArray = Array.isArray(components);
  if (!isArray) return [];

  const {
    metaTitle,
    lightboxImages = [],
    toggleModal,
    open,
    selectedImage,
    setSelectedImage,
    parent,
    name: parentName
  } = options;

  if (rootLevel && !open) StoreImages.resetImages();

  StoreImages.addImages(getLightboxImages(components).concat(lightboxImages), options);
  StoreImages.setHandlers({ toggleModal, setSelectedImage });

  const imageProps = {
    toggleModal: StoreImages.toggleModal,
    handleSelectedImage: StoreImages.handleSelectedImage
  };

  const images = StoreImages.images.map(image => ({ ...image, ...imageProps }));

  return (
    <>
      {open && (
        <GlobalLightbox
          images={images}
          onClose={StoreImages.toggleModal}
          selectedImage={selectedImage}
          metaTitle={metaTitle}
          parentName={parentName}
          parent={parent}
        />
      )}
      {components.map(component => {
        const { items = [] } = component;
        const [
          hasElementInsertionComponents,
          elementInsertionComponents
        ] = getComponentsToInsertByType(items, ELEMENT);

        const [hasTextBlockBanners, textBlockBanners] = getComponentsToInsertByType(
          items,
          PB_TYPE_TEXTBLOCK
        );

        let updatedChildren =
          items &&
          cloneDeep(items).filter(
            ({ settings: { insertionType } = {} }) => insertionType !== PB_TYPE_TEXTBLOCK
          );

        if (hasElementInsertionComponents) {
          updatedChildren = injectElementComponents(elementInsertionComponents, updatedChildren);
        } else {
          // TODO: this block is for banner retrocompatibility, once completly migrated remove it as well as all related helpers
          const bannerToInject = checkBannerInsertionSet(updatedChildren);
          const bannerIndex = getBannerIndex(updatedChildren, bannerToInject);
          const hasComponentItems = !!(updatedChildren && updatedChildren.length);

          if (hasComponentItems && bannerIndex > -1) {
            updatedChildren = insertBanners(updatedChildren, bannerIndex, bannerToInject);
          }
        }

        const childComponents = renderChildComponents(options, updatedChildren);

        return (
          <RenderComponent
            component={component}
            siblings={updatedChildren}
            childComponents={childComponents}
            imageProps={imageProps}
            options={{ ...options }}
            images={images}
            key={`${component.id}`}
            hasTextBlockBanners={hasTextBlockBanners}
            textBlockBanners={textBlockBanners}
          />
        );
      })}
    </>
  );
}

export default BuildPBComponents;
